import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2, Mail } from "lucide-react";
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus("error");
        setMessage("Ungültiger Verifizierungslink");
        return;
      }

      try {
        const response = await api.post(`/api/auth/verify-email?token=${token}`);
        setStatus("success");
        setMessage(response.data.message);
      } catch (error) {
        setStatus("error");
        setMessage(error.response?.data?.detail || "Fehler bei der Verifizierung");
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <div className="min-h-screen login-bg flex items-center justify-center p-4" data-testid="verify-email-page">
      <div className="login-overlay absolute inset-0"></div>
      
      <Card className="w-full max-w-md relative z-10 shadow-xl border-0 animate-fadeIn">
        <CardHeader className="text-center pb-2">
          <img src="/vytech-logo.png" alt="VyWork" className="h-20 w-auto mx-auto mb-4" />
          <CardTitle className="text-2xl font-bold">
            E-Mail-Verifizierung
          </CardTitle>
        </CardHeader>

        <CardContent>
          <div className="text-center space-y-4">
            {status === "loading" && (
              <>
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                  <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
                </div>
                <p className="text-muted-foreground">E-Mail wird verifiziert...</p>
              </>
            )}
            
            {status === "success" && (
              <>
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                  <CheckCircle2 className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-lg font-semibold text-green-600">Erfolgreich!</h3>
                <p className="text-muted-foreground">{message}</p>
                <Link to="/login">
                  <Button className="w-full mt-4">
                    Zum Login
                  </Button>
                </Link>
              </>
            )}
            
            {status === "error" && (
              <>
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto">
                  <XCircle className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-lg font-semibold text-red-600">Fehler</h3>
                <p className="text-muted-foreground">{message}</p>
                <Link to="/login">
                  <Button variant="outline" className="w-full mt-4">
                    Zum Login
                  </Button>
                </Link>
              </>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default VerifyEmailPage;
